import { createSelector } from 'reselect';

import getCart from '@core/reducers/cart/selectors/getCart';

const getNeedsToAdd = createSelector(
  getCart,
  cart => (cart && cart.needsToAdd) || 0,
);

export default getNeedsToAdd;
